import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  FormInput
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import * as positionActions from "../../../actions/other_info/position.action";
import * as departmentActions from "../../../actions/other_info/department.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import moment from "moment";
import { Button, Radio, message, Modal } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import jwt_decode from "jwt-decode";

class MeetingReportConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      meeting: '',
      positions: [],
      departments: [],
      id: '',
      name: '',
      position: '',
      department: '',
      isAccepted: true,
      description: '',
      loadingModalVisible: false
    };
  }

  async componentDidMount() {
    const token = localStorage.getItem("token")
    
    if(token) {
      await this.getMeeingDetail()
    } else {
      this.setState({loadingModalVisible: true})
    }
  }

  async loginWithEmail()  {
    if(!this.state.email)  {
      message.error('กรุณากรอกอีเมล');

      return
    }
    
    try {
      const response = await httpClient.post(
        `/api/authentication/email`,
        { 
          email: this.state.email 
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("token", response.data)
      const user = jwt_decode(response.data);
      localStorage.setItem('user_profile',JSON.stringify(user));      

      await this.getMeeingDetail()
      this.setState({loadingModalVisible: false})
    } catch(err)  {
      if(err.response.status === 404) {
        message.error('ไม่พบอีเมลนี้ในระบบ');
      }
    }
  }

  async getMeeingDetail() {
    this.setState({loading: true})
    const attendeeId = new URLSearchParams(this.props.location.search).get("id")
    await this.props.getMeetingById(this.props.match.params.id);
    await this.props.getAllPositions(this.state.currentPage);
    await this.props.getAllDepartments(this.state.currentPage);

    try {
      const response = await httpClient.get(
        `/api/meetings/${this.props.meetingReducer.result.id}/attendee/${attendeeId}`,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      this.setState({
        meeting: this.props.meetingReducer.result,
        id: response.data.id,
        name: response.data.name,
        position: response.data.positionName,
        department: response.data.dapartmentName,
        positions: this.props.positionsReducer.positions,
        departments: this.props.departmentReducer.departments
      })
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการโหลดข้อมูล กรุณาตรวจสอบความถูกต้องของลิงก์');
    }

    this.setState({loading: false})
  }

  async confirmReponse()  {
    
    try {
      const response = await httpClient.post(
        `/api/meetings/${this.props.meetingReducer.result.id}/attendee/${this.state.id}/confirm/response`,
        {
          response: this.state.isAccepted ? '1' : '2',
          description: this.state.isAccepted ? '' : this.state.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      );

      message.success('บันทึกข้อมูลเรียบร้อยแล้ว');

    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการโหลดข้อมูล กรุณาตรวจสอบความถูกต้องของลิงก์');
    }
  }

  render() {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <Card className="my-5">
                <CardBody>
                  <h5 className="font-weight-bold pb-3 text-center">แบบตอบรับการรับรองรายงานการประชุม</h5>

                  <p className="font-16 line-30 mb-3">
                    <span className="ml-5">ตามที่ได้มีการ</span>{this.state.meeting.title} ครั้งที่ {this.state.meeting.sequence}/{this.state.meeting.year + 543} เมื่อวันที่ 
                    <span className="mx-2">{this.state.meeting && moment(this.state.meeting.meetingStart).format("DD MMMM")}</span>
                    <span className="mr-2">{this.state.meeting && parseInt(moment(this.state.meeting.meetingStart).format("YYYY")) + 543}</span>
                    เวลา {this.state.meeting && moment(this.state.meeting.meetingStart).format("HH.mm")} - {this.state.meeting && moment(this.state.meeting.meetingEnd).format("HH.mm")} น. 
                    ณ {this.state.meeting.roomName} {this.state.meeting.buildingName} {this.state.meeting.locationName}
                  </p>

                  <p className="font-16 line-30">
                    <span className="ml-5">ข้าพเจ้า</span> <span className="font-weight-bold ml-2 mr-4">{this.state.name}</span>
                    ตำแหน่ง <span className="font-weight-bold ml-2 mr-4">{this.state.position}</span> 
                    หน่วยงาน <span className="font-weight-bold ml-2 mr-4">{this.state.department}</span> 
                    ได้พิจารณารายงานการประชุมแล้วเห็นว่า
                  </p>
                  
                  {/* <Row form>
                    <Col md="12" className="form-group">
                      <label>ชื่อ-สกุล</label>
                      <FormInput
                        name="name"
                        id="name"
                        onChange={(e) => this.setState({name: e.target.value})}
                        value={this.state.name}
                      />
                    </Col>
                  </Row>
                  <Row form>
                    <Col md="4" className="form-group">
                      <label>ตำแหน่ง</label>
                      <FormSelect
                        name="position"
                        id="position"
                        onChange={(e) => this.setState({position: e.target.value})}
                        value={this.state.position}
                      >
                        {this.state.positions.map((item) => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </FormSelect>
                    </Col>
                    <Col md="8" className="form-group">
                      <label>หน่วยงาน</label>
                      <FormSelect
                        name="department"
                        id="department"
                        onChange={(e) => this.setState({department: e.target.value})}
                        value={this.state.department}
                      >
                        {this.state.departments.map((item) => {
                          return (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </FormSelect>
                    </Col>
                  </Row> */}

                  <div className="text-center">
                    <Radio.Group onChange={(e) => this.setState({isAccepted: e.target.value})} value={this.state.isAccepted}>
                      <Radio value={true}>
                        ถูกต้องและขอรับรองรายงานการประชุม
                      </Radio>
                      <Radio value={false}>
                        มีข้อความต้องแก้ไขคือ
                      </Radio>
                    </Radio.Group>
                  </div>

                  { !this.state.isAccepted && 
                    <div className="mail-editor mt-4">
                      <ReactQuill 
                        theme="snow" 
                        value={this.state.description} 
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline'],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'align': null}, {'align': 'center'}, {'align': 'right'}],
                            ['link']
                          ]
                        }}
                        onChange={(value) => this.setState({description: value})}
                      />
                    </div>
                  }

                  <div className="text-center mt-5">
                    <Button 
                      type="primary" 
                      style={{width: 100}}
                      onClick={() => this.confirmReponse()}
                    >บันทึก</Button>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>

        <Modal 
          title="เข้าสู่ระบบ" 
          visible={this.state.loadingModalVisible}
          width={400}
          footer={null}
          maskClosable={false}
        >
          <FormGroup className="mt-2">
            <FormInput
              name="email"
              id="email"
              placeholder="อีเมลแอดเดรส"
              value={this.state.email}
              onChange={(e) => this.setState({email: e.target.value})}
            />
          </FormGroup>

          <div className="text-center mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.loginWithEmail()}
            >
              เข้าสู่ระบบด้วยอีเมล
            </button>
          </div>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = ({ 
  meetingReducer,
  positionsReducer,
  departmentReducer
}) => ({ 
  meetingReducer,
  positionsReducer,
  departmentReducer
});

const mapDispatchToProps = {
  ...actions,
  ...positionActions,
  ...departmentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(MeetingReportConfirm);
